export const INVALID_PHONE_MSG = `输入的手机号不正确，暂只支持中国大陆手机号`;
